export const FETCH_TYPIST_WORKLOAD_LIST = "[TYPIST] FETCH_TYPIST_WORKLOAD_LIST";
export const FETCH_TYPIST_WORKLOAD_LIST_START = "[TYPIST] FETCH_TYPIST_WORKLOAD_LIST_START";
export const FETCH_TYPIST_WORKLOAD_LIST_SUCCESS = "[TYPIST] FETCH_TYPIST_WORKLOAD_LIST_SUCCESS";
export const FETCH_TYPIST_WORKLOAD_LIST_ERROR = "[TYPIST] FETCH_TYPIST_WORKLOAD_LIST_ERROR";

export const SET_TYPIST_WORKLOAD_LIST_FILTER_AND_SORT = "[TYPIST] SET_TYPIST_WORKLOAD_LIST_FILTER_AND_SORT";
export const SET_TYPIST_WORKLOAD_LIST_PAGINATION = "[TYPIST] SET_TYPIST_WORKLOAD_LIST_PAGINATION";
export const SET_TYPIST_WORKLOAD_LIST_AUTO_NEXT_VISIT = "[TYPIST] SET_TYPIST_WORKLOAD_LIST_AUTO_NEXT_VISIT";
export const RESET_TYPIST_WORKLOAD_LIST_FILTER = "[TYPIST] RESET_TYPIST_WORKLOAD_LIST_FILTER";

export const getTypistWorkloadList = (payload) => {
    return {
        type: FETCH_TYPIST_WORKLOAD_LIST,
        payload
    };
};

export const setTypistWorkloadListFilterAndSort = (payload) => {
    return {
        type: SET_TYPIST_WORKLOAD_LIST_FILTER_AND_SORT,
        payload
    };
};

export const setTypistWorkloadListAutoNextVisit = (autoNextVisit) => {
    return {
        type: SET_TYPIST_WORKLOAD_LIST_AUTO_NEXT_VISIT,
        autoNextVisit
    };
};

export const resetTypistWorkloadListFilter = () => {
    return {
        type: RESET_TYPIST_WORKLOAD_LIST_FILTER
    };
};
